module.exports = __webpack_public_path__ + "img/kn_arrow_right.f574affc.svg";